import * as fromRouter from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';
import * as fromPrequal from './prequal.reducer';
import * as fromRoot from './root.reducer';

export interface State {
  router: fromRouter.RouterReducerState<any>;
  root: fromRoot.RootState;
  prequal: fromPrequal.PrequalState;
}

export const reducers: ActionReducerMap<State> = {
  router: fromRouter.routerReducer,
  root: fromRoot.appReducer,
  prequal: fromPrequal.reducer,
};
